import { Button } from "@omni/ui/components/Button/button.component";
import classNames from "classnames";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { Spinner } from "../Spinner/spinner.component";
import "./pagination.scss";

type PaginationComponentProps = {
    statusText: string;
    currentNumberOfHits: number;
    totalNumberOfHits: number;
    hitsToLoad: number;
    loading: boolean;
    onClick: () => void;
    className?: string;
};

const PaginationComponent = ({
    statusText,
    currentNumberOfHits,
    totalNumberOfHits,
    hitsToLoad,
    loading,
    onClick,
    className
}: PaginationComponentProps) => {
    const { t } = useGranite();

    return (
        <section className={classNames("pagination", className)}>
            <div>
                <span
                    className={"pagination__label mb-2"}
                    dangerouslySetInnerHTML={{ __html: statusText }}
                />
                <progress
                    className={"pagination__progress-bar w-100"}
                    max={totalNumberOfHits}
                    value={currentNumberOfHits}
                    aria-valuemin={0}
                    aria-valuemax={totalNumberOfHits}
                    aria-valuenow={currentNumberOfHits}
                />
                {currentNumberOfHits < totalNumberOfHits && (
                    <Button
                        className={"pagination__button mt-2"}
                        type="button"
                        onClick={onClick}
                        color={"gray"}
                        fullWidth={true}
                    >
                        {loading && <Spinner size={"sm"} />}
                        {!loading &&
                            t("search.pagination.loadMore", hitsToLoad)}
                    </Button>
                )}
            </div>
        </section>
    );
};

export { PaginationComponent };
